import { CONTRACT_TYPES } from '../../../../constants/reports/reports-data';
import { handlePerpetualsPerAccount } from '../risk-data-per-account';

const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

export const handlePerpetuals = (riskType: string, breakdowns: any[], perpetualType: string) => {
  const hasAnyBooks = breakdowns.some((bk: any) => bk.book);

  if (!hasAnyBooks) {
    return handlePerpetualsPerAccount(riskType, breakdowns, perpetualType);
  }

  const contractName = `${CONTRACT_TYPES.PERPETUAL} (${perpetualType})`;

  const totalAllBooks = breakdowns.find(
    (bk: any) => bk.contract === contractName && bk.book === 'ALL' && bk.instrument === 'ALL',
  );
  if (!totalAllBooks) return null;

  const uniqueBooks = Array.from(
    new Set(
      breakdowns
        .filter((bk: any) => bk.contract === contractName && bk.book !== 'ALL')
        .map((bk: any) => bk.book),
    ),
  );

  const bookChildren = uniqueBooks.map((bookName: string) => {
    const totalBook = breakdowns.find(
      (bk: any) => bk.contract === contractName && bk.book === bookName && bk.instrument === 'ALL',
    );
    const bookValues = totalBook ? totalBook.risk : [];

    const breakdownsForBook = breakdowns.filter(
      (bk: any) => bk.contract === contractName && bk.book === bookName && bk.instrument !== 'ALL',
    );

    const children = breakdownsForBook.map((bk: any) => ({
      id: `${riskType}-${bk.instrument}`,
      label: bk.instrument,
      position: bk.position,
      values: bk.risk,
    }));

    return {
      id: `${riskType}-perpetual-${perpetualType.toLowerCase()}-book-${bookName}`,
      label: bookName,
      position: 'Position',
      values: bookValues,
      children: children,
    };
  });

  return {
    id: `${riskType}-perpetual-${perpetualType.toLowerCase()}`,
    label: `Perpetuals (${capitalizeFirstLetter(perpetualType)})`,
    values: totalAllBooks.risk,
    children: bookChildren,
  };
};
